module.exports = __webpack_public_path__ + "static/media/smart_contract_system_p.17111824.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/smart_contract_system_p.jpg
// module id = 367
// module chunks = 0